import { Avatar } from '@nexo/ui';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../lib/api';
import { formatDay, formatTime } from '../../lib/format';
import { AdminPage, DataTable, Pagination } from './AdminLayout';

export function AdminAudit() {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const audit = useQuery({
    queryKey: ['admin', 'audit', page],
    queryFn: () => api.admin.audit(page),
    placeholderData: keepPreviousData,
  });
  return (
    <AdminPage
      title={t('Actividad')}
      description={t('Registro de todas las acciones realizadas desde la administración.')}
    >
      <DataTable
        head={[t('Cuándo'), t('Quién'), t('Acción')]}
        empty={audit.data?.items.length === 0}
      >
        {audit.data?.items.map((entry) => (
          <tr key={entry.id}>
            <td className="px-4 py-2.5 whitespace-nowrap text-muted">
              {formatDay(entry.createdAt)} · {formatTime(entry.createdAt)}
            </td>
            <td className="px-4 py-2.5">
              {entry.actor ? (
                <span className="flex items-center gap-2">
                  <Avatar
                    id={entry.actor.id}
                    name={entry.actor.displayName}
                    src={entry.actor.avatarUrl}
                    size="xs"
                  />
                  {entry.actor.displayName}
                </span>
              ) : (
                <span className="text-subtle">{t('Cuenta eliminada')}</span>
              )}
            </td>
            <td className="px-4 py-2.5">
              {entry.summary} <code className="ml-1 text-[11px] text-subtle">{entry.action}</code>
            </td>
          </tr>
        ))}
      </DataTable>
      {audit.data && (
        <Pagination
          page={audit.data.page}
          pageSize={audit.data.pageSize}
          total={audit.data.total}
          onPage={setPage}
        />
      )}
    </AdminPage>
  );
}
